import { Text, HStack, VStack, Box } from '@chakra-ui/react';
import { ReactNode } from 'react';
import {
  getMessageBubbleBgColor,
  getMessageBubbleTextColor,
} from './conversation-utils';
import Markdown from '@/components/markdown';

export const MessageSender = ({
  senderName,
  isUser,
  dateTime,
  isAIAgent = false,
  message,
  hideMessage,
  hasAttachments,
}: {
  senderName: string;
  isUser: boolean;
  dateTime: string;
  isAIAgent?: boolean;
  message: ReactNode;
  hideMessage: boolean;
  hasAttachments: boolean;
}) => {
  return (
    <VStack gap={1} alignItems={isUser ? 'flex-start' : 'flex-end'}>
      <HStack gap={1} alignItems="flex-start">
        <HStack gap={1} alignItems="center" justifyContent="space-between">
          <Text
            fontSize={'sm'}
            color={isUser ? 'gray.900' : 'gray.400'}
            style={{ fontWeight: isUser ? 'bold' : 'normal' }}
            textTransform="capitalize"
          >
            {isUser ? senderName : dateTime}
          </Text>
          <Text
            fontSize={'sm'}
            color={isUser ? 'gray.400' : 'gray.900'}
            style={{ fontWeight: isUser ? 'normal' : 'bold' }}
            textTransform={isUser ? 'capitalize' : 'none'}
          >
            {isUser ? dateTime : senderName}
          </Text>
        </HStack>
      </HStack>
      {!hideMessage && message && (
        <Box
          borderRadius="lg"
          width="100%"
          position="relative"
          backgroundColor={getMessageBubbleBgColor(isUser, isAIAgent)}
          color={getMessageBubbleTextColor(isUser, isAIAgent)}
          px={5}
          py={1}
          maxWidth="fit-content"
          alignSelf="flex-start"
        >
          <Markdown
            content={hasAttachments ? 'Media message' : (message as string)}
          />
        </Box>
      )}
    </VStack>
  );
};
